import * as Icons from "@material-ui/icons";

import { Menu as FobMenu, MenuGroup, MenuItem } from "ra-friendsofbabba";
import React, { Fragment, useMemo } from "react";
import {
  usePermissions,
  useQuery,
  useQueryWithStore,
  useTranslate,
} from "react-admin";

import { APP_URL } from "../config";

const createPageLink = (page) => `/pages/${page.id}/show`;

const MenuContentGroup = ({
  translate,
  open,
  location,
  onMenuClick,
  menu,
  filter,
}) => {
  const groups = useMemo(() => menu.filter((g) => filter(g)), [menu, filter]);

  return groups.map((group, idx) => (
    <MenuGroup
      key={idx}
      open={open}
      label={translate(`menu.groups.${group.label}`)}
    >
      {group.items.map((item, index) => (
        <MenuItem
          {...item}
          key={index}
          open={open}
          location={location}
          onMenuClick={onMenuClick}
        />
      ))}
    </MenuGroup>
  ));
};
const MenuContent = ({ menu, open, location, onMenuClick, translate }) => {
  const { data } = useQueryWithStore({
    type: "get",
    resource: "pages",
    payload: { is_menu: true },
  });

  const pages = data?.data;

  return (
    <Fragment>
      <MenuContentGroup
        menu={menu}
        open={open}
        translate={translate}
        location={location}
        onMenuClick={onMenuClick}
        filter={(g) => g.label !== "admin"}
      />
      <MenuGroup open={open} label={translate("menu.groups.links")}>
        {pages?.map((page, index) => (
          <MenuItem
            key={index}
            open={open}
            location={location}
            icon={Icons.Link}
            label={page.name}
            to={createPageLink(page)}
          />
        ))}
      </MenuGroup>
      <MenuContentGroup
        menu={menu}
        open={open}
        translate={translate}
        location={location}
        onMenuClick={onMenuClick}
        filter={(g) => g.label === "admin"}
      />
    </Fragment>
  );
};

const Menu = (props) => {
  const translate = useTranslate();
  const { data: pages } = useQuery({
    resource: "pages/menu",
    type: "get",
  });
  const { data: badges } = useQuery({
    resource: "stats/badges",
    type: "get",
  });

  const { permissions } = usePermissions();
  const isAdmin = useMemo(
    () => permissions && permissions(["admin"]),
    [permissions]
  );

  return (
    <FobMenu
      {...props}
      mode="custom"
      order={{
        dashboard: 10,
        admin: 100,
        pages: 1000,
      }}
      items={pages?.data?.map((page) => ({
        name: page.name,
        path: `/pages/${page.id}/show`,
        label: page.name,
        icon: Icons.Info,
        group: "pages",
        localize: false,
      }))}
      badges={badges?.data}
    >
      <MenuContent {...props} translate={translate} isAdmin={isAdmin} />
      <MenuGroup label={translate("menu.groups.contacts")}>
        <MenuItem
          icon={Icons.Email}
          label={translate("menu.items.contact_tech")}
          sub={translate("menu.items.contact_tech.help")}
          href="mailto:assistenza.stradaperstrada@regione.puglia.it"
        />
        <MenuItem
          icon={Icons.Info}
          label={translate("menu.items.contact_info")}
          sub={translate("menu.items.contact_info.help")}
          href="mailto:stradaperstrada@pec.rupar.puglia.it"
        />
        <MenuItem
          icon={Icons.Dock}
          label={translate("menu.items.documentation")}
          sub={translate("menu.items.documentation.help")}
          href={`${APP_URL}assets/Guida Utente.pdf`}
        />
      </MenuGroup>
      <MenuGroup label={translate("menu.group.online_help")}>
        {[
          "EL1 - elaborati di progetto",
          "EL2 - Delib CC variazione bilancio",
          "EL3 - Delib GC approvazione progetto",
          "EL4 - Disciplinare di gara",
          "EL5 - Lettera di invito",
          "Cartellonistica",
        ].map((file) => (
          <MenuItem
            icon={Icons.PictureAsPdf}
            key={file}
            label={file}
            href={`${APP_URL}assets/${file}.pdf`}
          />
        ))}
        ;
      </MenuGroup>
    </FobMenu>
  );
};

export default Menu;
